
import { Options, Vue } from 'vue-property-decorator'

@Options({
  name: 'FooterLogo'
})
export default class FooterLogo extends Vue {}
